// extracted by mini-css-extract-plugin
export default {"main":"display_slides_main__JfcmS","container":"display_slides_container__XBJDJ","slide":"display_slides_slide__wzF5t"};